import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { useTaskStatus, TaskStatus } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<TaskStatus>
      useData={useTaskStatus}
      config={{
        ...moduleConfig,
        getDetailSections,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;
